var defaultColor = '#E9E9EA';
var predefinedColors = {
    "date": "#BB92FF",
    "loc": "#EF83EF",
    "org": "#8CBAFF",
    "person": "#47D475",
    "number": "#FFA759",
    "ordinal": "#FFFC5E",
    "duration": "#FF7A9A"
};

var predefinedRandomColors = [
    "#FFCBCB",
    "#FFE4CB",
    "#FFF7CB",
    "#FDFF8F",
    "#FF8E8E",
    "#FFC998",
    "#FEEC90",
    "#B8FF5F",
    "#82FF87",
    "#82FF87",
    "#00D1FF",
    "#9C8CFF",
    "#FD96FF",
    "#E8FFCB",
    "#CBFFCD",
    "#C7FF8F",
    "#CBFFFC",
    "#9CD0FF",
    "#D2CBFF",
    "#FECBFF",
];

var usedColors = {
    currentIndex: 0,
    usedColors: [],
    getColor: function (text) {
        text = this.hashCode(text);

        if (this.usedColors[text]) {
            return this.usedColors[text];
        } else {
            if (this.currentIndex < predefinedRandomColors.length) {
                this.usedColors[text] = predefinedRandomColors[this.currentIndex];
                this.currentIndex++;
                return this.usedColors[text];
            } else {
                this.currentIndex = 0;
            }
        }
    },
    hashCode(str) {
        var hash = 0, i, chr;
        if (str.length === 0) return hash;
        for (i = 0; i < str.length; i++) {
            chr = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0;
        }
        return hash;
    }
};

function djb2(str) {
    var hash = 5381;
    for (var i = 0; i < str.length; i++) {
        hash = ((hash << 5) + hash) + str.charCodeAt(i);
    }
    return hash;
}

function hashStringToColor(str) {
    var hash = djb2(str);
    var r = (hash & 0xFF0000) >> 16;
    var g = (hash & 0x00FF00) >> 8;
    var b = hash & 0x0000FF;
    return '#' + ('0' + r.toString(16)).substr(-2) + ('0' + g.toString(16)).substr(-2) + ('0' + b.toString(16)).substr(-2);
}

function hexToRgbA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')';
    }
    return defaultColor;//default avatar color
}

function getColorByText(text, opacity) {
    if (text) {
        text = text.toLowerCase();
        if (predefinedColors[text]) {
            return hexToRgbA(predefinedColors[text], opacity);
        } else if (usedColors.getColor(text)) {
            return hexToRgbA(usedColors.getColor(text), opacity);
        }

        return hexToRgbA(hashStringToColor(text), opacity);
    }
    return defaultColor;
}

function getClassByColor(color, opacity) {
    let prefix = 'random';
    opacity *= 10;
    opacity = opacity.toFixed(0);
    const randomIndex = predefinedRandomColors.findIndex(c => c === color);
    let index = Math.max(randomIndex, 0);
    if (color === defaultColor) {
        prefix = 'default';
    } else if (Object.keys(predefinedColors).some(key => predefinedColors[key] === color)) {
        index = Object.keys(predefinedColors).find(key => predefinedColors[key] === color);
        prefix = 'predefined';
    }
    return `alan-color-${prefix}-${index} alan-opacity-${opacity}`;
}

export function resetUsedColors() {
    usedColors.usedColors = [];
    usedColors.currentIndex = 0;
}

export function getColorClassByText(text, opacity = 1) {
    let color = defaultColor;
    if (text) {
        text = text.toLowerCase();
        if (predefinedColors[text]) {
            color = predefinedColors[text];
        } else if (usedColors.getColor(text)) {
            color = usedColors.getColor(text);
        } else {
            color = hashStringToColor(text);
        }
    }
    return getClassByColor(color, opacity);
}

export default getColorByText;
